import { useMemo } from 'react';
import { getSeriesColors } from '@shopify/polaris-viz-core';

function getFilteredSeriesCount(series) {
  var _series$filter$length;

  // Only include solid lines (or non-lines) in the
  // count when grabbing the series color.
  return (_series$filter$length = series.filter(item => {
    return item.isComparison !== true;
  }).length) !== null && _series$filter$length !== void 0 ? _series$filter$length : 0;
} // Build an array of colors for each item in the series. Colors provided directly
// to series.color are used in place of the theme color.


function useThemeSeriesColors(series, selectedTheme) {
  return useMemo(() => {
    const seriesCount = getFilteredSeriesCount(series);
    const seriesColors = getSeriesColors(seriesCount, selectedTheme);
    let lastUsedColorIndex = -1;
    return series.map(({
      color,
      isComparison
    }) => {
      if (isComparison === true) {
        return selectedTheme.seriesColors.comparison;
      } // If the series doesn't have a color property
      // explicitly set on itself, we're going to grab
      // the next available color in the array.


      if (!color) {
        lastUsedColorIndex += 1; // Once we've hit the last item in the array,
        // reset the count and grab the first color.

        if (lastUsedColorIndex === seriesColors.length) {
          lastUsedColorIndex = 0;
        }

        return seriesColors[lastUsedColorIndex];
      }

      return color;
    });
  }, [series, selectedTheme]);
}

export { useThemeSeriesColors };
